import { validatorFns } from "@jauntin/reactables";
import { RxFormProviders } from "@reactables/forms";
import { normalizers as importedNormalizers } from "@jauntin/utilities";
import * as gbliValidators from "./gbliValidators";
import * as gbliNormalizers from "./gbliNormalizers";

type NormalizerFunction<T> = (value: T) => T;
const normalizers = importedNormalizers as {
  [key: string]: NormalizerFunction<unknown>;
};

const formProviders: RxFormProviders = {
  validators: {
    ...validatorFns(),
    ...gbliValidators,
  },
  normalizers: {
    ...normalizers,
    ...gbliNormalizers,
  },
};

export default formProviders;
